import {
  FlexColumn,
  FlexRow,
  SectionContainer,
  SectionInner,
  TextContainer,
} from "components/rhombus-UI/theme/containers";
import { SectionTitle } from "components/rhombus-UI/theme/typography";
import React from "react";
import image1 from "./assets/streamlined-management-min.png";
import image2 from "./assets/ai-powered-min.png";
import image3 from "./assets/infastructure-min.png";
import image4 from "./assets/security-min.png";

import { styled } from "@linaria/react";
import TestimonialCard from "./TestimonialCard";

const PLATFORM_CARDS = [
  {
    image: image1,
    title: "Streamlined Management",
    blurb: "Control all locations, users, and devices from a single dashboard.",
  },
  {
    image: image2,
    title: "AI-Powered Intelligence",
    blurb:
      "Automatic alerts and smart detection reduce manual monitoring and response times.",
  },
  {
    image: image3,
    title: "Zero Infrastructure Overhead",
    blurb:
      "Cloud-first architecture eliminates costly on-premise servers & bandwidth.",
  },
  {
    image: image4,
    title: "Advanced Security",
    blurb:
      "Enterprise-grade encryption and automatic updates keep your system secure.",
  },
];

const CardContainer = styled(FlexRow)`
  gap: 5rem;
  flex-wrap: wrap;
  justify-content: center;
`;

const PlatformCard = styled(FlexColumn)`
  border-radius: 1rem;
  overflow: hidden;
  height: 600px;
  width: calc(50% - 5rem);
  .image {
    flex-grow: 1;
    aspect-ratio: 600/440;
    background-color: ${(props) => props.bgColor};
    overflow: hidden;
    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
      object-position: bottom;
    }
  }
  .text {
    background-color: ${(props) => props.color};
    padding: 1.25rem;
    min-height: 160px;
    flex-grow: 1;
    h2 {
      font-size: 32px;
      line-height: 1.2;
    }
    p {
      font-size: 18px;
      line-height: 32px;
    }
  }
  @media (min-width: 1440px) {
    .image {
      img {
        object-fit: cover;
      }
    }
  }

  @media (max-width: 1024px) {
    height: 440px;
    .text {
      h2 {
        font-size: 24px;
      }
      p {
        font-size: 16px;
      }
    }
  }
  @media (max-width: 820px) {
    height: 440px;
    width: 100%;
    max-width: 440px;
  }
`;

const PlatformCards = ({ cardColor, cards, cardBgColor }) => {
  return (
    <CardContainer>
      {cards.map((item) => (
        <PlatformCard color={cardColor} bgColor={cardBgColor}>
          <div className="image">
            {!!item.image && <img src={item.image} />}
          </div>
          <TextContainer className="text">
            <h2>{item.title}</h2>
            <p>{item.blurb}</p>
          </TextContainer>
        </PlatformCard>
      ))}
    </CardContainer>
  );
};

const PlatformF = ({
  title = "One Platform. Complete Control.",
  bgColor = "var(--nuetral-100)",
  cardColor = "var(--white)",
  cardBgColor = "#dbe5ef",
  showTestimonial = true,
  cards = PLATFORM_CARDS,
}) => {
  return (
    <SectionContainer color={bgColor}>
      <SectionInner className="flex-col" style={{ gap: "5rem" }}>
        <SectionTitle>{title}</SectionTitle>
        <PlatformCards
          cardColor={cardColor}
          cardBgColor={cardBgColor}
          cards={cards}
        />
        {showTestimonial && <TestimonialCard cardColor={cardColor} />}
      </SectionInner>
    </SectionContainer>
  );
};

export default PlatformF;
